<template>
    <div class="cards-main__slider swiper">
        <div class="cards-main__wrapper swiper-wrapper" id="complexes-container">
            <div class="loader-container" v-if="isLoading">
                <loader-gray></loader-gray>
            </div>
            <div class="cards-main__slide swiper-slide"
                 v-for="complex in complexes"
                 :key="complex.id"
            >
                <catalog-complex-card
                    :complex="complex"
                    :is-slider="true"
                ></catalog-complex-card>
            </div>
        </div>
        <div class="cards-main__pagination swiper-pagination"></div>
    </div>
</template>

<script>
import Swiper, {EffectFade, Navigation, Pagination} from 'swiper';
import LoaderGray from "../loaders/LoaderGray.vue";

export default {
    name: "ComplexSlider",
    components: {LoaderGray},
    props: {
        complexes: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            swiper: null,
            nextPage: 2,
            isLoading: false
        }
    },
    methods: {
        initSwiperCards() {
            this.isLoading = true;
            let arrsPrev = document.querySelectorAll(".cards-main-button_prev");
            let arrsNext = document.querySelectorAll(".cards-main-button_next");
            let cardMainSlider = document.querySelectorAll(".cards-main__slider");
            for (let index = 0; index < cardMainSlider.length; index++) {
                const slider = cardMainSlider[index];
                this.swiper = new Swiper(slider, {
                    modules: [Pagination, Navigation],
                    observer: true,
                    observeParents: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    speed: 800,
                    watchOverflow: true,
                    effect: "fade",
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true
                    },
                    navigation: {
                        prevEl: arrsPrev[index],
                        nextEl: arrsNext[index]
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 10
                        },
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 30
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 30
                        }
                    },
                    on: {}
                });
            }
            this.isLoading = false;
        },
        initSwiperImages() {
            let cardSliders = document.querySelectorAll(".card__slider");

            cardSliders.forEach((slider, index) => {
                new Swiper(slider, {
                    modules: [Pagination, EffectFade, Navigation],
                    observer: true,
                    observeParents: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    speed: 800,
                    watchOverflow: true,
                    effect: "fade",
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    breakpoints: {
                        320: {},
                        768: {
                            touchRatio: 0,
                            navigation: {
                                prevEl: ".card-button_prev",
                                nextEl: ".card-button_next"
                            }
                        }
                    },
                    on: {
                        touchStart: (e) => {
                            if (this.swiper) {
                                this.swiper.allowTouchMove = false;
                            }
                        },
                        touchEnd: (e) => {
                            if (this.swiper) {
                                this.swiper.allowTouchMove = true;
                            }
                        }
                    }
                });
            });
        }
    },
    mounted() {
        this.initSwiperCards();
        this.$nextTick(() => {
            this.initSwiperImages();
        })
    }
}
</script>
